@import "../../../../shared/scss";

:host {
  position: fixed;
  z-index: $phn-z-index-mega-flyout;
  inset: 0;
  background-color: rgba(0, 0, 0, 0);
  opacity: 0;
  cursor: pointer;
  @include pds-frosted-glass();

  &.pointer-events-none {
    pointer-events: none;
  }

  &.fade-in-animation {
    animation: fade-in-animation 400ms;
  }

  &.fade-out-animation {
    animation: fade-in-animation 400ms reverse;
  }
}
